import React from 'react'

interface PasswordPolicyIndicatorProps {
    password: string;
    onValidChange?: (isValid: boolean) => void;
}

const rules = [
    { check: (pw: string) => pw.length >= 8, label: '8자 이상' },
    { check: (pw: string) => pw.length <= 64, label: '64자 이하' },
]

const PasswordPolicyIndicator: React.FC<PasswordPolicyIndicatorProps> = ({ password, onValidChange }) => {
    const results = rules.map(rule => ({
        label: rule.label,
        passed: password.length > 0 ? rule.check(password) : false,
    }))

    const allPassed = password.length > 0 && results.every(r => r.passed)

    React.useEffect(() => {
        onValidChange?.(allPassed)
    }, [allPassed, onValidChange])

    if (password.length === 0) return null

    return (
        <div className={'flex flex-col gap-[4px] mt-[6px] text-xs'}>
            {results.map(({ label, passed }) => (
                <div key={label} className={'flex items-center gap-[4px]'}>
                    <span className={passed ? 'text-green-600' : 'text-red-500'}>
                        {passed ? '✓' : '✗'}
                    </span>
                    <span className={passed ? 'text-gray-600' : 'text-red-500'}>
                        {label}
                    </span>
                </div>
            ))}
        </div>
    )
}

export default PasswordPolicyIndicator
